import React from 'react';
import { ChecklistEditorContext, ChecklistEditorDispatchContext } from './checklist-editor-context';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { Actions } from './checklist-editor-reducer';
import { useContextSelector } from 'use-context-selector';

export function ChecklistPropertiesPanel() {
    const title = useContextSelector(ChecklistEditorContext, state => state.title);
    const inactive = useContextSelector(ChecklistEditorContext, state => state.inactive);
    const dispatch = useContextSelector(ChecklistEditorDispatchContext, state => state);

    const renameChecklist = (e) => {
        dispatch({
            type: Actions.RENAME_CHECKLIST,
            payload: {
                title: e.target.value,
            },
        });
    };

    const toggleChecklistInactive = (e) => {
        dispatch({
            type: Actions.TOGGLE_CHECKLIST_INACTIVE,
            payload: {
                inactive: e.target.checked,
            },
        });
    };

    return (
        <Form onSubmit={ (e) => e.preventDefault() }>
            <FormGroup inline>
                <Label for={ 'checklist-title' }>
                    Title
                </Label>
                <Input
                    name={ 'checklist-title' }
                    placeholder={ 'Checklist title' }
                    defaultValue={ title }
                    onChange={ renameChecklist }
                />
            </FormGroup>

            <FormGroup
                check
                inline
            >
                <Input
                    id={ 'checklist-inactive' }
                    type={ 'checkbox' }
                    defaultChecked={ inactive }
                    onChange={ toggleChecklistInactive }
                />
                <Label
                    for={ 'checklist-inactive' }
                    check
                >
                    Inactive
                </Label>
            </FormGroup>
        </Form>
    );
}
